module.exports = __webpack_public_path__ + "img/arrow_down.65eb61ed.svg";